import { nativeGooglePayAdapter } from './nativeGooglePay'
import { nativeApplePayAdapter } from './nativeApplePay'
import { checkIsNativeApp } from 'utils/nativeApp'
import { googlePayAdapter } from './googlePay'
import { applePayAdapter } from './applePay'
import { WalletAdapter } from '../types'

/** klucz = walletForm.wallet, NIE provider - arkusz wygląda tak samo dla każdej bramki */
export const walletAdapters: Record<payments.WalletKey, WalletAdapter> = {
  gpay: googlePayAdapter,
  applepay: applePayAdapter
}

/** W natywnej appce (iOS/Android) most do appki zamiast web-owego SDK - patrz nativeGooglePay.ts / nativeApplePay.ts */
const nativeWalletAdapters: Partial<Record<payments.WalletKey, WalletAdapter>> = {
  gpay: nativeGooglePayAdapter,
  applepay: nativeApplePayAdapter
}

export const getWalletAdapter = (walletForm?: payments.WalletForm) => {
  if (!walletForm?.wallet) return undefined
  if (checkIsNativeApp()) return nativeWalletAdapters[walletForm.wallet]
  return walletAdapters[walletForm.wallet]
}